/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Menu/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import AppointmentsAction from './AppointmentsAction/index'
import CommsAction from './CommsAction/index'
import FinancialAction from './FinancialAction/index'
import HomeAction from './HomeAction/index'
import Logo from './Logo/index'
import LogoutAction from './LogoutAction/index'
import ProfileAction from './ProfileAction/index'
import React from 'react'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Menu({
  children,
  viewPath = "/App/Account/Content/Menu"
  
}) {
  let isMedia = useIsMedia()
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Menu.Horizontal"
  data-view-path={viewPath}
 style={{'--pb-6-axv1': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-3-axv1': isMedia.laptop ? dtColorsWhite : dtColorsWhite,'--pt-9-axv1': isMedia.laptop ? typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS : typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-7-axv1': isMedia.laptop ? typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS : "0px",'--pr-8-axv1': isMedia.laptop ? typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS : "0px",'--jc-1-axv1': isMedia.laptop ? "center" : "space-around",'--btlr-4-axv1': isMedia.laptop ? "0px" : "0px",'--btrr-5-axv1': isMedia.laptop ? "0px" : "0px",'--fd-10-axv1': isMedia.laptop ? "column" : "row",'--h-2-axv1': isMedia.laptop ? "100%" : "auto"}}
 className={`views-block new-shadow ${styles.Horizontal}`}
>
<fromFlow.When is={isMedia.laptop}>
<Logo
  viewPath={`${viewPath}/Logo`}
/>
</fromFlow.When>
<HomeAction
  viewPath={`${viewPath}/HomeAction`}
/>
<AppointmentsAction
  viewPath={`${viewPath}/AppointmentsAction`}
/>
<CommsAction
  viewPath={`${viewPath}/CommsAction`}
/>
<FinancialAction
  viewPath={`${viewPath}/FinancialAction`}
/>
<ProfileAction
  viewPath={`${viewPath}/ProfileAction`}
/>
<LogoutAction
  viewPath={`${viewPath}/LogoutAction`}
/>
</div>
{children}
</React.Fragment>)
}